import z from 'zod'
import { AttachmentIdSchema } from './ids'

export const RangeFilterSchema = z.object({
  gte: z.number().optional(),
  lte: z.number().optional(),
})
export type RangeFilter = z.infer<typeof RangeFilterSchema>
const CustomFieldIdSchema = z.templateLiteral(['CF.', z.string()]).meta({
  description: `A unique identifier for the custom field set`,
  example: `CF.123-4aBc_d`,
})
export const CustomFieldTypeSchema = z.union([z.string(), z.number(), z.boolean(), AttachmentIdSchema, z.null()])

export const CustomFieldValueSchema = z.union([CustomFieldTypeSchema, z.array(CustomFieldTypeSchema)])
export type CustomFieldValue = z.infer<typeof CustomFieldValueSchema>

export const CustomFieldMapSchema = z.record(CustomFieldIdSchema, CustomFieldValueSchema)
export type CustomFieldMap = z.infer<typeof CustomFieldMapSchema>

export const WithCustomFieldsSchema = z.object({
  customFields: CustomFieldMapSchema.optional(),
})

export type WithCustomFields = z.infer<typeof WithCustomFieldsSchema>

export const CustomFieldFilterValueSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('range'), range: RangeFilterSchema }),
  z.object({ type: z.literal('multipleChoice'), values: z.array(CustomFieldTypeSchema).min(1) }),
  z.object({ type: z.literal('exists'), exists: z.boolean() }),
])
export type CustomFieldFilterValue = z.infer<typeof CustomFieldFilterValueSchema>

export const CustomFieldFilterSchema = z.record(CustomFieldIdSchema, CustomFieldFilterValueSchema)

export type CustomFieldFilter = z.infer<typeof CustomFieldFilterSchema>

export const CustomFieldsWithNameSchema = z.object({
  id: CustomFieldIdSchema,
  name: z.string(),
  value: CustomFieldTypeSchema,
})

export type CustomFieldsWithName = z.infer<typeof CustomFieldsWithNameSchema>
